/* eslint no-console:0 */

import "./stylesheets/application.scss"
import "./javascripts/application.js"

require.context('./images', true)
require.context('./fonts', true)
